import { useDispatch, useSelector } from "react-redux";
import { MailType } from "../../../models/Mail";
import { AppDispatch, RootState } from "../../../state/store";
import { useTranslation } from "react-i18next";
import { Fragment, useEffect, useState } from "react";
import { Toast } from "../../Toast";
import { useForm } from "react-hook-form";
import { createAgencyMailType, updateAgencyMailType } from "../../../state/mail/actions";
import { toast, ToastContainer } from "react-toastify";
import { SmallModal } from "../../SmallModal";
import { ReactiveFormInput } from "../../form/ReactiveFormInput";
import { LoadingMask } from "../../LoadingMask";

interface Props {
    info: {
        show: boolean;
        update: boolean;
        type?: MailType;
        index?: number;
    };
    onClose: () => void;
}

export const AgencyMailTypeModal: React.FC<Props> = ({
    info,
    onClose
}) => {
    const dispatch = useDispatch<AppDispatch>();
    const { t } = useTranslation();
    const currentUser = useSelector((state: RootState) => state.users.currentUser);
    const isLoading = useSelector((state: RootState) => state.mails.isLoading);
    const error = useSelector((state: any) => state.mails.error);
    const [showMailTypeError, setShowMailTypeError] = useState(false);

    useEffect(() => {
        if (showMailTypeError) {
            Toast(
                t(error?.reason ?? "SOMETHING_WENT_WRONG"),
                t(error?.cause_info)
            );
        }
    }, [showMailTypeError, error, t]);

    const methods = useForm<MailType>({})
    const { handleSubmit, control, setValue, reset } = methods;

    useEffect(() => {
        info.type ? reset(info.type) : reset({});
    }, [info.type, reset]);

    const onSubmit = (data: MailType) => {
        if (info.update) {
            //TODO: update
            dispatch(updateAgencyMailType({agencyId: currentUser?.agency?.id!, typeId: info.type?.id!, updateMailType: data})).then((e) => {
                if (e.type === "mail/updateAgencyMailType/rejected") {
                    setShowMailTypeError(true);
                } else {
                    toast(t("SUCCESSFULLY_UPDATE_AGENCY_MAIL_TYPE"));
                    closeModal();
                }
            });
        } else {
            //Todo: add
            dispatch(createAgencyMailType({agencyId: currentUser?.agency?.id!, newMailType: data})).then((e) => {
                if (e.type === "mail/createAgencyMailType/rejected") {
                    setShowMailTypeError(true);
                } else {
                    toast(t("SUCCESSFULLY_CREATE_AGENCY_MAIL_TYPE"));
                    closeModal();
                }
            });
        }
    }

    const closeModal = () => {
        reset({});
        onClose();
    };

    return (<>
        <SmallModal
            isOpen={info.show}
            onClose={closeModal}
            label={info.update ? t("UPDATE_TYPE") : t("ADD_TYPE")}
            onSave={handleSubmit(onSubmit)}
        >
            <div className="w-full flex flex-wrap">
                <Fragment>
                    <ReactiveFormInput
                        control={control}
                        className="md:w-1/2"
                        label={t("CODE")}
                        name={`code`}
                        isRequired
                    />
                    <ReactiveFormInput
                        control={control}
                        className="md:w-1/2"
                        label={t("NAME")}
                        name={`name`}
                        isRequired
                    />
                </Fragment>
            </div>
        </SmallModal>
        <ToastContainer progressStyle={{ background: "#D4AF37" }} />
        { isLoading && <LoadingMask />}
    </>)
}